export default "__VITE_ASSET__DHgygXF4__"